import script from "./ReasonSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReasonSelection.vue?vue&type=script&setup=true&lang=js"

import "./ReasonSelection.vue?vue&type=style&index=0&id=567f6da7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567f6da7"]])

export default __exports__